export const getId = config => `${config.property}_${config.aggregation}`;